<div class="container-fluid px-3">
    <div class="nav-container">
        <a class="nav-link" routerLink="overview" routerLinkActive="active-link" matTooltip="View course overview"
            matTooltipClass="custom-tooltip">Overview</a>

        <!-- <a class="nav-link" routerLink="study-material" routerLinkActive="active-link"
            matTooltip="Access shared resources" matTooltipClass="custom-tooltip">Study-material</a> will used this component later-->

           <a class="nav-link" routerLink="course" routerLinkActive="active-link" matTooltip="View courses"
            matTooltipClass="custom-tooltip">Courses</a>
			 <a class="nav-link" routerLink="quiz" routerLinkActive="active-link" matTooltip="View quiz"
            matTooltipClass="custom-tooltip">Quizzes</a>
        <a class="nav-link" routerLink="members" routerLinkActive="active-link" matTooltip="View class members"
            matTooltipClass="custom-tooltip">Members</a>
    </div>
    <router-outlet></router-outlet>
</div>